import Vue from 'vue';

Number.prototype.toSkString = function (minDigits = 2, maxDigits = 2) {
  return this.valueOf().toLocaleString('sk-SK', {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
  });
};

Number.prototype.toPercentString = function (digits = 0) {
  return (
    this.valueOf().toLocaleString('sk-SK', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    }) + '%'
  );
};

Number.prototype.toEurString = function () {
  return (
    this.valueOf().toLocaleString('sk-SK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + '€'
  );
};

String.prototype.formatDate = function () {
  let parsedDate = Date.parse(this.valueOf());

  if (parsedDate) return new Intl.DateTimeFormat('en-GB').format(parsedDate);

  return this.valueOf();
};

String.prototype.replaceAt = function (index, replacement) {
  return this.substr(0, index) + replacement + this.substr(index + replacement.length);
};

// String.prototype.formatDate = function () {
//   let parsedDate = Date.parse(this.valueOf());

//   if (parsedDate) return new Intl.DateTimeFormat('sk-SK',{
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit'
//   }).format(parsedDate);

//   return this.valueOf();
// };

String.prototype.formatDateTime = function () {
  let parsedDate = Date.parse(this.valueOf());

  if (parsedDate)
    return new Intl.DateTimeFormat('sk-SK', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }).format(parsedDate);

  return this.valueOf();
};

String.prototype.trimSpaces = function () {
  return this.valueOf().replace(/\s/g, '');
};

String.prototype.toDatePickerDate = function () {
  let parsedDate = Date.parse(this.valueOf());

  if (parsedDate) return new Intl.DateTimeFormat('sv-SE').format(parsedDate).split(' ')[0];

  return this.valueOf();
};

String.prototype.toStrictInt = function () {
  if (
    (this.valueOf().length > 1 &&
      !this.valueOf().includes('.') &&
      !this.valueOf().includes(',') &&
      (this.valueOf().charAt(0) === '0' ||
        this.valueOf().charAt(0) === '+' ||
        this.valueOf().charAt(0) === '-')) ||
    this.valueOf().length == 0
  )
    return NaN;
  else return Number(this.valueOf());
};

Number.prototype.getTenor = function () {
  return this.valueOf() + " mes.";
};

Number.prototype.formatSuffix = function (suffix) {
  return this.valueOf() >= 0 ? this.valueOf() + suffix : " ";
}

export default {
  modelToPostData(model) {
    return Object.entries(model).map(e => {
      const [key, value] = e;
      return {
        ColumnName: key,
        ControlValue: !value && value !== 0 ? null : value.toString(),
      };
    });
  },
  groupBy(list, keyGetter, displayGetter) {
    let grouped = [];
    list.forEach(item => {
      let key = keyGetter(item);
      let display = '';
      if (displayGetter) {
        display = displayGetter(item);
      }
      let currentParent = grouped.filter(f => f.key == key);
      if (currentParent.length == 0) {
        grouped.push({
          key: key,
          display: display,
          children: [item],
        });
      } else {
        currentParent[0].children.push(item);
      }
    });
    return grouped;
  },
  GuidEmpty(){
    return "00000000-0000-0000-0000-000000000000"
  }
};
